module.exports = __webpack_public_path__ + "img/night-middle-bg_zh.6e7d3dec.png";